import { Box } from "@mui/system";
import { palette } from "../../themes/theme";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import moveIcon from "../../assets/icons/icon_move.svg";
import toolWarpIcon from "../../assets/icons/icon_tool_wrap.svg";
import addImageIcon from "../../assets/icons/icon_add_image.svg";
import addTextIcon from "../../assets/icons/icon_tool_text.svg";
import rectangleIcon from "../../assets/icons/icon_rectangle.svg";
import groupIcon from "../../assets/icons/icon_group.svg";
import undoIcon from "../../assets/icons/icon_undo.svg";
import redoIcon from "../../assets/icons/icon_redo.svg";
import { IconButton, styled } from "@mui/material";
import { useContext, useState } from "react";
import { CustomPolygonClass } from "../../component/MapSettings/utilities/CustomPolygon";
import { CustomDraggable } from "../../component/Draggable";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { MapToolboxContext } from "../../context/mapToolbox/mapToolbox.provider";

const StyledIconButton = styled(IconButton)((props) => ({
  background: props.active ? palette.primary.main : "black",
  border: `1px solid ${palette.text.white60}`,
  borderRadius: "5px",
  width: "100%",
  height: "50px",
}));

export const MapToolsBox = ({
  mapRef,
  drawRef,
  // showPolygonStyleSettings,
  setPolygonSelected,
  createPolygon,
  setMapToolBarOptionFlags,
  resetActiveId,
  resetMapToolbarOptionFlags,
  setShapeSettings,
  resetAllOnceChanged,
  isClusterCallOutRef,
}) => {
  const { activeId, setActiveId } = useContext(MapToolboxContext);

  const handleArrowClick = () => {
    resetMapToolbarOptionFlags();
    resetAllOnceChanged();
    if (activeId === "arrow") {
      resetActiveId();
      return;
    }
    mapRef.getCanvas().style.cursor = "default";
    setActiveId("arrow");
  };

  const handleToolWrapClick = () => {
    resetMapToolbarOptionFlags();
    resetAllOnceChanged();
    if (activeId === "tool-wrap-polygon") {
      resetActiveId();
      return;
    }
    setMapToolBarOptionFlags((d) => ({ ...d, polygon: true }));
    setActiveId("tool-wrap-polygon");
    setPolygonSelected(null);
    createPolygon();
    mapRef.getCanvas().style.cursor = "crosshair";
  };

  const handleAddImageClick = () => {
    resetMapToolbarOptionFlags();
    resetAllOnceChanged();
    if (activeId === "add-image") {
      resetActiveId();
      return;
    }
    setMapToolBarOptionFlags((d) => ({ ...d, logoUpload: true }));
    mapRef.getCanvas().style.cursor = "crosshair";
    setActiveId("add-image");
  };

  const handleAddTextClick = () => {
    resetMapToolbarOptionFlags();
    resetAllOnceChanged();
    if (activeId === "add-text") {
      resetActiveId();
      return;
    }
    mapRef.getCanvas().style.cursor = "crosshair";
    setMapToolBarOptionFlags((d) => ({ ...d, textSetting: true }));
    setActiveId("add-text");
  };

  const handleShapeClick = () => {
    resetMapToolbarOptionFlags();
    resetAllOnceChanged();
    if (activeId === "shape") {
      resetActiveId();
      return;
    }
    mapRef.getCanvas().style.cursor = "crosshair";
    setShapeSettings((previousValue) => {
      previousValue.addShapeToMapFlag = true;
      previousValue.addSelectedShapeFlag = "fa-sharp fa-solid fa-square";
      return previousValue;
    });
    setActiveId("shape");
  };

  const handleGroupClick = () => {
    resetMapToolbarOptionFlags();
    resetAllOnceChanged();
    if (activeId === "group") {
      isClusterCallOutRef.current = false;
      resetActiveId();
      return;
    }
    isClusterCallOutRef.current = true;
    createPolygon();
    mapRef.getCanvas().style.cursor = "crosshair";
    setActiveId("group");
  };

  return (
    <CustomDraggable
      isToolbox
      width={80}
      height={410}
      customComponent={
        <Box
          sx={{
            width: 80,
            background: palette.background.dark,
            borderRadius: "12px",
            position: "absolute",
            zIndex: 4,
            boxShadow: "1px 3px 12px black",
            paddingBottom: "12px",
          }}
        >
          <div
            style={{
              // padding: "0px 0 4px 20px",
              justifySelf: "center",
              cursor: "all-scroll",
            }}
            className="draggable-header"
          >
            <DragIndicatorIcon
              sx={{
                transform: "rotate(90deg)",
              }}
              fontSize="large"
              color="secondary"
            />
          </div>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              px: 2,
              gap: "10px",
            }}
          >
            <StyledIconButton
              active={activeId === "arrow"}
              onClick={handleArrowClick}
            >
              <img src={moveIcon} alt="arrow" />
            </StyledIconButton>
            <StyledIconButton
              active={activeId === "tool-wrap-polygon"}
              onClick={handleToolWrapClick}
            >
              <img src={toolWarpIcon} alt="tool-wrap-polygon" />
            </StyledIconButton>
            <StyledIconButton
              active={activeId === "add-image"}
              onClick={handleAddImageClick}
            >
              <img src={addImageIcon} alt="add-image" />
            </StyledIconButton>
            <StyledIconButton
              active={activeId === "add-text"}
              onClick={handleAddTextClick}
            >
              <img src={addTextIcon} alt="add-text" />
            </StyledIconButton>
            <StyledIconButton
              active={activeId === "shape"}
              onClick={handleShapeClick}
            >
              <img src={rectangleIcon} alt="shape" />
            </StyledIconButton>
            {/* <StyledIconButton
              active={activeId === "group"}
              onClick={handleGroupClick}
            >
              <img src={groupIcon} alt="group" />
            </StyledIconButton> */}
            {/* <StyledIconButton disabled>
              <img src={undoIcon} alt="undo" />
            </StyledIconButton>
            <StyledIconButton disabled>
              <img src={redoIcon} alt="redo" />
            </StyledIconButton> */}
          </Box>
        </Box>
      }
    />
  );
};
